var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["pagination-previous.j2"] = require( "pagination-previous.j2" );
dependencies["pagination-next.j2"] = require( "pagination-next.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/pagination-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/macros/pagination-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
if(t_1.hasOwnProperty("productUrl")) {
var t_5 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_5);
if(t_1.hasOwnProperty("searchUrl")) {
var t_6 = t_1.searchUrl;
} else {
cb(new Error("cannot import 'searchUrl'")); return;
}
context.setVariable("searchUrl", t_6);
if(t_1.hasOwnProperty("brandsUrl")) {
var t_7 = t_1.brandsUrl;
} else {
cb(new Error("cannot import 'brandsUrl'")); return;
}
context.setVariable("brandsUrl", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
["source", "totalPages", "currentPage"], 
["nextPage", "prevPage", "slug", "categoryPagingLocation"], 
function (l_source, l_totalPages, l_currentPage, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("source", l_source);
frame.set("totalPages", l_totalPages);
frame.set("currentPage", l_currentPage);
frame.set("nextPage", kwargs.hasOwnProperty("nextPage") ? kwargs["nextPage"] : {});
frame.set("prevPage", kwargs.hasOwnProperty("prevPage") ? kwargs["prevPage"] : {});
frame.set("slug", kwargs.hasOwnProperty("slug") ? kwargs["slug"] : "");
frame.set("categoryPagingLocation", kwargs.hasOwnProperty("categoryPagingLocation") ? kwargs["categoryPagingLocation"] : "");
var t_9 = "";t_9 += "\n\n    ";
if(l_source == "category") {
t_9 += "\n        ";
var t_10;
t_10 = (lineno = 6, colno = 30, runtime.callWrap(t_4, "categoryUrl", context, [runtime.contextOrFrameLookup(context, frame, "slug")]));
frame.set("url", t_10, true);
if(frame.topLevel) {
context.setVariable("url", t_10);
}
if(frame.topLevel) {
context.addExport("url", t_10);
}
t_9 += "\n        ";
var t_11;
t_11 = "category";
frame.set("pageCategory", t_11, true);
if(frame.topLevel) {
context.setVariable("pageCategory", t_11);
}
if(frame.topLevel) {
context.addExport("pageCategory", t_11);
}
t_9 += "\n    ";
;
}
else {
if(l_source == "product") {
t_9 += "\n        ";
var t_12;
t_12 = (lineno = 9, colno = 29, runtime.callWrap(t_5, "productUrl", context, [runtime.contextOrFrameLookup(context, frame, "slug")]));
frame.set("url", t_12, true);
if(frame.topLevel) {
context.setVariable("url", t_12);
}
if(frame.topLevel) {
context.addExport("url", t_12);
}
t_9 += "\n        ";
var t_13;
t_13 = "pdp";
frame.set("pageCategory", t_13, true);
if(frame.topLevel) {
context.setVariable("pageCategory", t_13);
}
if(frame.topLevel) {
context.addExport("pageCategory", t_13);
}
t_9 += "\n    ";
;
}
else {
if(l_source == "brands") {
t_9 += "\n        ";
var t_14;
t_14 = (lineno = 12, colno = 28, runtime.callWrap(t_7, "brandsUrl", context, [runtime.contextOrFrameLookup(context, frame, "slug")]));
frame.set("url", t_14, true);
if(frame.topLevel) {
context.setVariable("url", t_14);
}
if(frame.topLevel) {
context.addExport("url", t_14);
}
t_9 += "\n        ";
var t_15;
t_15 = "brand";
frame.set("pageCategory", t_15, true);
if(frame.topLevel) {
context.setVariable("pageCategory", t_15);
}
if(frame.topLevel) {
context.addExport("pageCategory", t_15);
}
t_9 += "\n    ";
;
}
else {
if(l_source == "search") {
t_9 += "\n        ";
var t_16;
t_16 = (lineno = 15, colno = 28, runtime.callWrap(t_6, "searchUrl", context, []));
frame.set("url", t_16, true);
if(frame.topLevel) {
context.setVariable("url", t_16);
}
if(frame.topLevel) {
context.addExport("url", t_16);
}
t_9 += "\n        ";
var t_17;
t_17 = "search";
frame.set("pageCategory", t_17, true);
if(frame.topLevel) {
context.setVariable("pageCategory", t_17);
}
if(frame.topLevel) {
context.addExport("pageCategory", t_17);
}
t_9 += "\n    ";
;
}
;
}
;
}
;
}
t_9 += "\n\n    ";
var t_18;
t_18 = (lineno = 19, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.analytics.productTypeSlug"]));
frame.set("brandAnalyticsSlug", t_18, true);
if(frame.topLevel) {
context.setVariable("brandAnalyticsSlug", t_18);
}
if(frame.topLevel) {
context.addExport("brandAnalyticsSlug", t_18);
}
if(runtime.contextOrFrameLookup(context, frame, "url")) {
t_9 += "<nav aria-label=\"pagination\" role=\"navigation\" class=\"o-pagination ";
t_9 += runtime.suppressValue((l_source == "category"?"c-category-header__pagination":""), env.opts.autoescape);
t_9 += "\" data-qa-pagination=\"true\">\n\n            <ul class=\"o-pagination__ul\">\n\n                <li class=\"o-pagination__li o-pagination__li--arrow\">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "prevPage")),"page")) {
t_9 += "<a\n                            data-cm-element=\"category_page_number\"\n                            data-element-name=\"page\"\n                            class=\"o-pagination__arrow o-pagination__arrow--previous js-pagination__arrow--previous\"\n                            data-page-number=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "prevPage")),"page"), env.opts.autoescape);
t_9 += "\"\n                            data-page-request=\"";
t_9 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "prevPage")),"queryString")), env.opts.autoescape);
t_9 += "\"\n                            data-qa-prevpage\n                            href=\"";
t_9 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "prevPage")),"queryString")) {
t_9 += "?";
;
}
t_9 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "prevPage")),"queryString")), env.opts.autoescape);
t_9 += "\"\n                            aria-label=\"";
t_9 += runtime.suppressValue((lineno = 38, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["pagination-arrow-previous-aria-label",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "prevPage")),"page"),l_totalPages]})])), env.opts.autoescape);
t_9 += "\"";
if(runtime.contextOrFrameLookup(context, frame, "pageCategory") == "pdp") {
t_9 += runtime.suppressValue((lineno = 40, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.contextOrFrameLookup(context, frame, "pageCategory"),runtime.contextOrFrameLookup(context, frame, "brandAnalyticsSlug"),"reviewpg prev"])), env.opts.autoescape);
;
}
else {
t_9 += runtime.suppressValue((lineno = 42, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["page num","prev"])), env.opts.autoescape);
;
}
t_9 += ">\n\n                            ";
env.getTemplate("pagination-previous.j2", false, "core/templates/macros/pagination-macro.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
t_9 += t_20
t_9 += "\n\n                        </a>\n                    ";
})});
}
else {
t_9 += "\n                        <span class=\"o-pagination__arrow o-pagination__arrow--previous o-pagination__arrow--disabled\" data-qa-prevpage aria-label=\"previous page\">\n\n                            ";
env.getTemplate("pagination-previous.j2", false, "core/templates/macros/pagination-macro.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
t_9 += t_24
t_9 += "\n\n                        </span>";
})});
}
t_9 += "\n\n                </li>\n\n                <li data-qa-current-page class=\"o-pagination__li o-pagination__number--current\">\n\n                    ";
t_9 += runtime.suppressValue(l_currentPage, env.opts.autoescape);
t_9 += "\n\n                </li>\n\n                <li class=\"o-pagination__li\" aria-hidden=\"true\">\n\n                    &#47;\n\n                </li>\n\n                <li data-qa-total-pages class=\"o-pagination__li o-pagination__number--next\">\n\n                    ";
t_9 += runtime.suppressValue(l_totalPages, env.opts.autoescape);
t_9 += "\n\n                </li>\n\n                <li class=\"o-pagination__li o-pagination__li--arrow\">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "nextPage")),"page")) {
t_9 += "<a\n                            data-cm-element=\"category_page_number\"\n                            data-element-name=\"page\"\n                            class=\"o-pagination__arrow o-pagination__arrow--next js-pagination__arrow--next\"\n                            data-page-number=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "nextPage")),"page"), env.opts.autoescape);
t_9 += "\" data-page-request=\"";
t_9 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "nextPage")),"queryString")), env.opts.autoescape);
t_9 += "\"\n                            data-qa-nextpage\n                            href=\"";
t_9 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
t_9 += "?";
t_9 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "nextPage")),"queryString")), env.opts.autoescape);
t_9 += "\"\n                            aria-label=\"";
t_9 += runtime.suppressValue((lineno = 86, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["pagination-arrow-next-aria-label",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "nextPage")),"page"),l_totalPages]})])), env.opts.autoescape);
t_9 += "\"";
if(runtime.contextOrFrameLookup(context, frame, "pageCategory") == "pdp") {
t_9 += runtime.suppressValue((lineno = 88, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.contextOrFrameLookup(context, frame, "pageCategory"),runtime.contextOrFrameLookup(context, frame, "brandAnalyticsSlug"),"reviewpg next"])), env.opts.autoescape);
;
}
else {
t_9 += runtime.suppressValue((lineno = 90, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["page num","next"])), env.opts.autoescape);
;
}
t_9 += ">\n\n                            ";
env.getTemplate("pagination-next.j2", false, "core/templates/macros/pagination-macro.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
t_9 += t_28
t_9 += "\n\n                        </a>\n                    ";
})});
}
else {
t_9 += "\n                        <span class=\"o-pagination__arrow o-pagination__arrow--next o-pagination__arrow--disabled\" data-qa-nextpage aria-label=\"next page\">\n\n                            ";
env.getTemplate("pagination-next.j2", false, "core/templates/macros/pagination-macro.j2", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
t_9 += t_32
t_9 += "\n\n                        </span>";
})});
}
t_9 += "\n\n                </li>\n\n            </ul>\n\n        </nav>";
;
}
else {
t_9 += "<div class=\"o-pagination\" data-qa-pagination=\"false\">\n        </div>";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
context.addExport("buildPagination");
context.setVariable("buildPagination", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/pagination-macro.j2"] , dependencies)